import { retrieveToken } from '../storage';
import {
  wrapFetch,
  wrapFetchWithDetailedErrors,
  apiFetch,
  apiError,
  REGISTRAZIONE_DATI_NON_CORRETTI,
  REGISTRAZIONE_EMAIL_DUPLICATA,
  SALVATAGGIO_DATI_NON_CORRETTI,
} from './api';

const BASE_URL = process.env.REACT_APP_BACKEND_ENDPOINT;

export const getConsulenti = (consulenteId, gruppoId, page, size, sortby) => {
  const token = retrieveToken();
  const PATH = '/api/consulenti';
  let query =
    '?' +
    'page=' +
    page +
    '&size=' +
    size +
    '&sort=' +
    sortby +
    '&' +
    sortby +
    '.dir=ASC';
  if (consulenteId !== null) {
    query = query + '&id.equals=' + consulenteId;
  }
  if (gruppoId !== null && gruppoId !== -1) {
    query = query + '&gruppoId.equals=' + gruppoId;
  }
  const URL = BASE_URL + PATH + query;
  const authtoken = 'Bearer '.concat(token);
  return wrapFetch(
    apiFetch(URL, {
      method: 'GET',
      headers: {
        Authorization: authtoken,
      },
      withCredentials: true,
      credentials: 'include',
    }),
    apiError(),
  );
};

export const getConsulentiFiltered = (
  consulenteId,
  gruppoId,
  page,
  size,
  sortby,
  email,
  nome,
  cognome,
  telefono,
) => {
  const token = retrieveToken();
  const PATH = '/api/consulenti';
  let query =
    '?' +
    'page=' +
    page +
    '&size=' +
    size +
    '&sort=' +
    sortby +
    '&' +
    sortby +
    '.dir=ASC';
  if (consulenteId !== null && consulenteId !== '') {
    query = query + '&id.equals=' + consulenteId;
  }
  if (gruppoId !== null && gruppoId !== -1) {
    query = query + '&gruppoId.equals=' + gruppoId;
  }
  if (email !== null && email !== '') {
    query += `&email.contains=${encodeURIComponent(email)}`;
  }
  if (nome !== null && nome !== '') {
    query += `&nome.contains=${encodeURIComponent(nome)}`;
  }
  if (cognome !== null && cognome !== '') {
    query += `&cognome.contains=${encodeURIComponent(cognome)}`;
  }
  if (telefono) {
    query += `&telefono.contains=${encodeURIComponent(telefono)}`;
  }
  const URL = BASE_URL + PATH + query;
  const authtoken = 'Bearer '.concat(token);
  return wrapFetch(
    apiFetch(URL, {
      method: 'GET',
      headers: {
        Authorization: authtoken,
      },
      withCredentials: true,
      credentials: 'include',
    }),
    apiError(),
  );
};

export const getTotaleConsulenti = (
  gruppoId,
  consulenteId,
  email,
  nome,
  cognome,
  telefono,
) => {
  const token = retrieveToken();
  let PATH = '/api/consulenti/count';
  let hasQuery = false;

  if (gruppoId && gruppoId !== -1) {
    PATH += (hasQuery ? '&' : '?') + `gruppoId.equals=${gruppoId}`;
    hasQuery = true;
  }
  if (consulenteId) {
    PATH += (hasQuery ? '&' : '?') + `id.equals=${consulenteId}`;
    hasQuery = true;
  }
  if (email) {
    PATH +=
      (hasQuery ? '&' : '?') + `email.contains=${encodeURIComponent(email)}`;
    hasQuery = true;
  }
  if (nome) {
    PATH +=
      (hasQuery ? '&' : '?') + `nome.contains=${encodeURIComponent(nome)}`;
    hasQuery = true;
  }
  if (cognome) {
    PATH +=
      (hasQuery ? '&' : '?') +
      `cognome.contains=${encodeURIComponent(cognome)}`;
    hasQuery = true;
  }
  if (telefono) {
    PATH +=
      (hasQuery ? '&' : '?') +
      `telefono.contains=${encodeURIComponent(telefono)}`;
    hasQuery = true;
  }
  const URL = BASE_URL + PATH;
  const authtoken = 'Bearer '.concat(token);
  return wrapFetch(
    apiFetch(URL, {
      method: 'GET',
      headers: {
        Authorization: authtoken,
      },
      withCredentials: true,
      credentials: 'include',
    }),
    apiError(),
  );
};

export const registerConsulente = (isSuperconsulenteView, formData) => {
  if (isSuperconsulenteView) {
    return registerConsulenteWithoutRole(formData);
  } else {
    return registerConsulenteWithRole(formData);
  }
};

const registerConsulenteWithoutRole = (formData) => {
  const token = retrieveToken();
  const PATH = '/api/consulenti/registrazione';
  const URL = BASE_URL + PATH;
  const authtoken = 'Bearer '.concat(token);
  const requestBody = {
    email: formData.email,
    // password: formData.password,
    nome: formData.nome,
    cognome: formData.cognome,
    telefono: formData.telefono,
    terminiUsoAccettati: true,
    privacyPolicyAccettata: true,
    codiceSdi: formData.codiceSdi,
    pec: formData.pec,
    partitaIva: formData.partitaIva,
    gruppoId: formData.gruppoId,
    passwordEnabled: formData.passwordEnabled,
    oauthEnabled: formData.oauthEnabled,
    ...(formData.passwordEnabled ? { password: formData.password } : {}),
  };
  return wrapFetch(
    apiFetch(URL, {
      method: 'POST',
      headers: {
        Authorization: authtoken,
        'Content-Type': 'application/json',
      },
      withCredentials: true,
      credentials: 'include',
      body: JSON.stringify(requestBody),
    }),
    apiError({
      // 404 if the gruppoId does not correspond to a registered Gruppo
      400: REGISTRAZIONE_DATI_NON_CORRETTI,
      404: REGISTRAZIONE_DATI_NON_CORRETTI,
      409: REGISTRAZIONE_EMAIL_DUPLICATA,
    }),
  );
};

const registerConsulenteWithRole = (formData) => {
  const token = retrieveToken();
  const PATH = '/api/consulente';
  const URL = BASE_URL + PATH;
  const authtoken = 'Bearer '.concat(token);
  const requestBody = {
    email: formData.email,
    // password: formData.password,
    nome: formData.nome,
    cognome: formData.cognome,
    telefono: formData.telefono,
    terminiUsoAccettati: true,
    privacyPolicyAccettata: true,
    codiceSdi: formData.codiceSdi,
    pec: formData.pec,
    partitaIva: formData.partitaIva,
    gruppoId: formData.gruppoId,
    superconsulente: formData.superconsulente,
    passwordEnabled: formData.passwordEnabled,
    oauthEnabled: formData.oauthEnabled,
    ...(formData.passwordEnabled ? { password: formData.password } : {}),
  };
  return wrapFetchWithDetailedErrors(
    apiFetch(URL, {
      method: 'POST',
      headers: {
        Authorization: authtoken,
        'Content-Type': 'application/json',
      },
      withCredentials: true,
      credentials: 'include',
      body: JSON.stringify(requestBody),
    }),
    apiError({
      // 404 if the gruppoId does not correspond to a registered Gruppo
      400: REGISTRAZIONE_DATI_NON_CORRETTI,
      404: REGISTRAZIONE_DATI_NON_CORRETTI,
      409: REGISTRAZIONE_EMAIL_DUPLICATA,
    }),
  );
};

export const updateConsulente = (isAdmin, requestBody) => {
  const token = retrieveToken();
  let PATH = '/api/consulenti';
  if (isAdmin) {
    PATH = '/api/consulente';
  }
  const URL = BASE_URL + PATH;
  const authtoken = 'Bearer '.concat(token);
  return wrapFetch(
    apiFetch(URL, {
      method: 'PUT',
      headers: {
        Authorization: authtoken,
        'Content-Type': 'application/json',
      },
      withCredentials: true,
      credentials: 'include',
      body: JSON.stringify(requestBody),
    }),
    apiError({
      400: SALVATAGGIO_DATI_NON_CORRETTI,
      404: 'Errore salvataggio: consulente non trovato.',
    }),
  );
};
